import React from "react";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { useNavigate } from 'react-router-dom';
import { IoIosNotifications } from "react-icons/io";
import { Layout, Dropdown, Menu } from 'antd';
import { toast } from "react-toastify";
import { useAuth } from "../../context/authContext";

const { Header } = Layout;

const AdminHeader = ({ collapsed, setCollapsed }) => {
    const navigate = useNavigate();
    const { updateUser } = useAuth();

    const handleLogout = () => {
        toast.success("You are logged out");

        setTimeout(() => {
            updateUser(null);
            navigate("/");
        }, 1500);
    };

    const adminMenu = (
        <Menu>
            <Menu.Item key="logout" onClick={handleLogout}>
                Sign out
            </Menu.Item>
        </Menu>
    );

    return (
        <Header
            className="sticky-top d-flex justify-content-between ps-1 pe-5 header"
            style={{ color: "white", lineHeight: "10px" }}
        >
            {React.createElement(
                collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                {
                    className: "trigger",
                    onClick: () => setCollapsed(!collapsed),
                }
            )}

            <div className="d-flex gap-4 align-items-center">
                <div className="position-relative">
                    <IoIosNotifications className="fs-4" />
                    <span className="badge text-white bg-blue-600 rounded-circle p-1 position-absolute top-0 start-[65%] translate-y-[-25%]">
                        3
                    </span>
                </div>

                <Dropdown overlay={adminMenu} trigger={["click"]}>
                    <div role="button" className="d-flex flex-column">
                        <h5 className="mb-0">Admin</h5>
                        <span className="m-0">admin@glyph.com</span>
                    </div>
                </Dropdown>
            </div>
        </Header>
    );
};

export default AdminHeader;

